import { pdfjs } from 'react-pdf';

// Initialize the worker with a specific version
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/legacy/build/pdf.worker.min.js`; 